module.exports = __webpack_public_path__ + "img/question-mark-blue.a0dd4275.svg";